<template>

    <b-modal id="testModal" :title="title" size="xl" v-model="dialogOpen" @hidden="onDialogHidden" @close="checkForDataChangeAndClose" ok-only ok-variant="secondary" ok-title="Close" no-close-on-backdrop>
        <div v-if="watchedAvailability">
            <div id="weekly_header" style="margin:10px;">
                <b-table-simple hover fixed class="table table-bordered">
                    <b-thead>
                        <b-tr>
                            <b-th><b-form-select id="change_whole_week" v-model="weeklySelected" :options="weeklyNonAvailabilityOptions" @change="changeAvailabilityForWholeWeek(weeklySelected)"></b-form-select></b-th>
                            <b-th style="font-size: 20px;" v-for="day in weekDayArray" :key="day" :variant="getVariantColor(day)" class="align-middle text-center">{{ day }}</b-th>
                        </b-tr>
                        <b-tr>
                            <b-th style="font-size: 18px;" class="align-middle text-left">Date</b-th>
                            <b-th style="font-size:16px;" v-for="(day,index) in watchedAvailability.days" :id="index" :key="index" :class="{ 'text-center': true, day: true, unavailable: (day.reasonUnavailable != null) }">{{ formatDateTime(day.date, 'DD/MM/YYYY', true, true) }}</b-th>
                        </b-tr>
                        <b-tr>
                            <b-th style="font-size: 18px;" class="align-middle text-left">Reasons</b-th>
                            <b-th v-for="(day,index) in watchedAvailability.days" style="font-size:20px;" :key="index" class="text-center">
                                <b-form-select v-model="day.reasonUnavailable" :options="dailyNonAvailabilityOptions" @change="changeAvailabilityForOneDay(day)" :disabled="isPastDate(day.date)" size="sm"></b-form-select>
                            </b-th>
                        </b-tr>
                        <b-tr>
                            <b-th style="font-size: 18px;" class="align-middle text-left">Comments</b-th>
                            <b-th v-for="(day,index) in watchedAvailability.days" style="font-size:20px;" :key="index" class="text-center">
                                <!-- each button has to have a unique ID, we combine the index with static text to get that -->
                                <b-button :ref="'commentsbutton' + index" :id="'commentsbutton' + index" :variant="getCommentsButtonVariant(index)" @click="onOpenPopover(index,day.date)" v-b-hover="day.comments" class="w-100" size="sm">
                                    comment
                                </b-button>
                               
                                <b-tooltip :target="'commentsbutton' + index" triggers="hover" variant="info" v-if="day.comments">
                                    {{ day.comments }}
                                </b-tooltip>
                                <!-- the popover has to have a target property set, we have to combine the index with a static text so that every popover has a different target (the button ID)
                                but we set the triggers property to manual, which means that the popover only opens/closes, when we change the sow property (commentsPopover[index].open) -->
                                <b-popover :target="'commentsbutton' + index"
                                           triggers="manual"
                                           placement="bottom"
                                           :show.sync="commentsPopover[index].open"
                                           custom-class="comments-popover"
                                           @shown="onPopoverShown(index)"
                                           @hidden="onPopoverHidden(index)"
                                           if="commentsPopover && commentsPopover!=null">

                                    <template #title>
                                        <b-button @click="onClosePopover(index)" class="close" aria-label="Close">
                                            <span class="d-inline-block" aria-hidden="true">&times;</span>
                                        </b-button>
                                        Comment
                                    </template>
                                    <div>
                                        <b-form-textarea :ref="'comments' + index"
                                                         name="comments"
                                                         v-model="commentsPopover[index].comments"
                                                         rows="5"></b-form-textarea>
                                        <b-button @click="onSavePopover(index)" class="float-right mt-3 mb-2" size="sm" variant="primary">Add Comment</b-button>
                                        <b-button @click="onClosePopover(index)" class="float-right mt-3 mb-2 mr-2" size="sm" variant="secondary">Cancel</b-button>
                                    </div>
                                </b-popover>
                            </b-th>
                        </b-tr>
                    </b-thead>
                </b-table-simple>
            </div>

            <div style="margin:10px;" v-if="watchedAvailability">
                <h5>Availability Times</h5>
                <b-table-simple hover fixed class="table table-bordered text-center">
                    <b-tbody>
                        <b-tr>
                            <b-td class="align-middle">Time Ranges</b-td>
                            <b-td v-for="(dayObj,amIndex) in watchedAvailability.days" :key="amIndex" class="m-0 align-middle" style="width: 12.5%;">
                                <!-- show the red badge -->
                                <template v-if="dayObj.reasonUnavailableDisplayName">
                                    <b-badge variant="danger" class="p-2 ml-2 mr-2 font-weight-light">{{ dayObj.reasonUnavailableDisplayName }}</b-badge>
                                </template>
                                <!-- show the grey badge -->
                                <template v-else-if="compressTimeSlots(dayObj.timeSlots)==0">
                                    <b-link href="#" @click="editAvailabilityDay(dayObj)" class="m-0 p-0">
                                        <b-badge variant="secondary" class="font-weight-light p-2">Add time ranges</b-badge>
                                    </b-link>
                                </template>
                                <!-- show the green badges -->
                                <template v-else-if="dayObj.timeSlots.length && compressTimeSlots(dayObj.timeSlots).length <= 5 ">
                                    <span v-for="(compressedTimeSlots,timeSlotIndex) in compressTimeSlots(dayObj.timeSlots)" :key="timeSlotIndex">
                                        <b-link href="#" @click="editAvailabilityDay(dayObj)" class="mt-0 pt-0">
                                            <b-badge variant="success" class="p-1 w-75 font-weight-light">{{ compressedTimeSlots.compressedDisplayText }}  </b-badge><br />
                                        </b-link>
                                    </span>
                                </template>
                                <!-- show the blue badge -->
                                <template v-else-if="compressTimeSlots(dayObj.timeSlots).length > 5">
                                    <b-link href="#" @click="editAvailabilityDay(dayObj)">
                                        <b-badge variant="primary" class=" font-weight-light p-2">{{  compressTimeSlots(dayObj.timeSlots).length }} time ranges</b-badge>
                                    </b-link>
                                </template>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>

            <div style="margin:10px;" v-if="watchedAvailability && (watchedAvailability.showAudioMinutes || watchedAvailability.showTravel || watchedAvailability.showOnSite || watchedAvailability.showRealTime)">
                <h5>Availability Options</h5>
                <b-table-simple hover fixed class="table table-bordered">
                    <b-tbody>
                        <b-tr v-if="watchedAvailability.showAudioMinutes">
                            <b-td>Delayed<br />(audio mins)</b-td>
                            <b-td v-for="(day,index) in watchedAvailability.days" :key="index" class="text-center">
                                <center>
                                    <b-form-input v-model="day.audioMinutes" @change="updateDataChangedStatus" size="sm" placeholder="mins" class="w-50 text-right" :disabled="((day.reasonUnavailable != null) || isPastDate(day.date))" />
                                </center>
                            </b-td>
                        </b-tr>
                        <b-tr v-if="watchedAvailability.showTravel">
                            <b-td>Travel</b-td>
                            <b-td v-for="(day,index) in watchedAvailability.days" :key="index" class="text-center">
                                <b-form-checkbox v-model="day.availableForTravel" @change="updateDataChangedStatus" :disabled="((day.reasonUnavailable != null) || isPastDate(day.date))" />
                            </b-td>
                        </b-tr>
                        <b-tr v-if="watchedAvailability.showOnSite">
                            <b-td>On site</b-td>
                            <b-td v-for="(day,index) in watchedAvailability.days" :key="index" class="text-center">
                                <b-form-checkbox v-model="day.availableForOnSite" @change="updateDataChangedStatus" :disabled="((day.reasonUnavailable != null) || isPastDate(day.date))" />
                            </b-td>
                        </b-tr>
                        <b-tr v-if="watchedAvailability.showRealTime">
                            <b-td>Real Time</b-td>
                            <b-td v-for="(day,index) in watchedAvailability.days" :key="index" class="text-center">
                                <b-form-checkbox v-model="day.availableForRealTime" @change="updateDataChangedStatus" :disabled="((day.reasonUnavailable != null) || isPastDate(day.date))" />
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>

            <b-popover target="info_week_edit" triggers="hover focus">
                <b-jumbotron class="p-2" lead="Single Availability Week - EDIT">
                    <p>
                        The content on this screen represents a single week of your availability.<br /><br />
                        You can either change the WHOLE weeks availability choosing the TOP LEFT
                        drop down and select a reason for your non-availability.<br /><br />
                        If you want to change the availability for ONE DAY please use the drop downs located under the weekdays DATE.<br /><br />
                        Alternatively you can tick/untick any checkbox individually. Once you are done: Press SAVE.<br /><br />
                        And no worries if any changes in your availability/circumstances arise you can re edit the same week as often as you want
                    </p>
                </b-jumbotron>
            </b-popover>

            <availability-day-edit :api-controller-url="apiControllerUrl"
                                   :title="dayEditModalTitle"
                                   :dateToEdit="dateToEdit"
                                   :dayToEdit="dayToEdit"
                                   :week-nr="weekNr"
                                   :timeZoneDisplayString="timeZoneDisplayString"
                                   v-model="showDayEdit"
                                   @availabilityUpdated="updateDataChangedStatus"></availability-day-edit>

            <b-modal ref="unsavedDataModal" hide-footer title="Unsaved Data Alert">
                <div class="d-block text-center">
                    <p>We noticed that you have unsaved data.</p>
                    <p>What do you want to do?</p>
                </div>
                <b-button class="mt-3" variant="secondary" block @click="hideUnsavedDataModal">Close this alert and save data</b-button>
                <b-button class="mt-2" variant="danger" block @click="exitUnsavedDataModal">Ignore this alert and exit</b-button>
            </b-modal>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <p class="float-left"><b-icon icon="question-circle-fill" id="info_week_edit" class="h2" variant="info"></b-icon></p>
                <b-button @click="saveAvailability" :disabled="!dataChanged" :variant="dataChanged ? 'success' : 'secondary'" class="float-right">Save</b-button>
                <b-button @click="checkForDataChangeAndClose" variant="secondary" class="float-right mr-1">Close</b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import Vue from 'vue';
    import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import AvailabilityDayEdit from './AvailabilityDayEdit';

    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);

    export default {
        name: 'AvailabilityWeekEdit',
        mixins: [ErrorsMixin, DateTimeMixin],
        components: {
            AvailabilityDayEdit
        },
        model: {
            event: 'change',
            prop: 'active',
        },
        props: {
            apiControllerUrl: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default: 'Availability Template'
            },
            title: {
                type: String,
                default: 'no title'
            },
            year: {
                type: Number,
                default: null
            },
            weekNr: {
                type: Number,
                default: null
            },
            userAccountId: {
                type: String,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            timeZoneDisplayString: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                availabilityUpdated: false,
                availability: null,
                dateToEdit: null,
                dayToEdit: null,
                showWeekEdit: false,
                showDayEdit: false,
                dayEditModalTitle: '',
                dataChanged: false,
                checkBoxToggleState: false,
                weeklySelected: '',
                weeklyNonAvailabilityOptions: null,
                dailySelected: [null, null, null, null, null, null, null],
                dailyNonAvailabilityOptions: null,
                weekDayArray: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],

                commentsPopover: [
                    {
                        open: false,
                        comments: null
                    },
                    {
                        open: false,
                        comments: null
                    },
                    {
                        open: false,
                        comments: null
                    },
                    {
                        open: false,
                        comments: null
                    },
                    {
                        open: false,
                        comments: null
                    },
                    {
                        open: false,
                        comments: null
                    },
                    {
                        open: false,
                        comments: null
                    }
                ]
            }
        },
        watch: {
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.loadAvailability();
                    this.availabilityUpdated = false;
                }
                this.dialogOpen = this.active;
            },
        },

        computed: {
            watchedAvailability: function () {
                return this.availability;
            }
        },

        methods: {

            numberOfAvailabletimeSlots(timeSlots) {
                var counter = 0;
                for (var i = 0; i < timeSlots.length; i++) {
                    if (timeSlots[i].selected) {
                        counter++;
                    } 
                }
                return counter;
            },

            compressTimeSlots: function (timeSlots) {
                var compressedTimeSlots = [];
                var startFound = false;
                var endFound = false;
                var compressedStartTime = '';
                var compressedEndTime = '';

                for (var i = 0; i < timeSlots.length; i++) {
                    if (timeSlots[i].selected && !startFound) {
                        // Scenario: start of compressed slot detected
                        compressedStartTime = timeSlots[i].timeSlotStartDisplayText;
                        compressedEndTime = timeSlots[i].timeSlotEndDisplayText;
                        startFound = true;
                    }
                    else if (startFound && !timeSlots[i].selected) {
                        // Scenario: end of compressed slot detected
                        compressedEndTime = timeSlots[i].timeSlotStartDisplayText;
                        endFound = true;
                    }
                    if ((startFound && endFound) || (i == 47 && timeSlots[i].selected)) {
                        // the last slot syndrome
                        if (i == 47 && timeSlots[i].selected) compressedEndTime = timeSlots[i].timeSlotEndDisplayText;
                        // 1 write spot, resetting flags
                        var obj = {};
                        obj.compressedDisplayText = compressedStartTime + ' - ' + compressedEndTime
                        compressedTimeSlots.push(obj);
                        startFound = false;
                        endFound = false;
                    }
                }
                return compressedTimeSlots;
            },

            showUnsavedDataModal: function () {
                this.$refs['unsavedDataModal'].show();
            },
            hideUnsavedDataModal: function () {
                this.$refs['unsavedDataModal'].hide();
            },
            exitUnsavedDataModal: function () {
                this.$refs['unsavedDataModal'].hide();
                this.dialogOpen = false;
            },

            loadAvailability: function () {
                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'week/' + this.year + '/' + this.weekNr;
                if (this.userAccountId) {
                    url += '/' + this.userAccountId;
                }
                axios
                    .get(url)
                    .then(response => {
                        this.availability = response.data;
                        this.dataChanged = false;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            saveAvailability: function () {

                var url = this.apiControllerUrl;

                for (var i = 0; i < 7; i++) {
                    var audioMinutesInput = this.availability.days[i].audioMinutes;
                    // digits only                    
                    var regEx = /^\d+$/;

                    // have to check audioMinutesInput for null and for '' because it changes value during use
                    // initially it is null and shows the placeholder 'mins' once edited it shows the placeholder 'mins' and a value of ''
                    if ((audioMinutesInput !== null && audioMinutesInput != '' && !regEx.test(audioMinutesInput)) ||
                        ((audioMinutesInput > 1440) ||  (audioMinutesInput < 0))) {
                        this.$bvToast.toast('Valid range: [0..1440] minuntes', {
                            title: 'Delayed audio minutes out of range',
                            variant: 'warning',
                            appendToast: true
                        });
                        return;
                    }
                }    

                if (!url.endsWith('/')) url += '/';
                url += 'week/' + this.year + '/' + this.weekNr;
                if (this.userAccountId) {
                    url += '/' + this.userAccountId;
                }

                console.log(JSON.stringify(this.availability));

                axios
                    .post(url, JSON.stringify(this.availability),
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        //this.loadAvailability(); // culprit candidate !!!!
                        this.availabilityUpdated = true;
                        this.$bvToast.toast('Availability saved successfully', {
                            title: 'Availability Saved',
                            variant: 'success',
                            appendToast: true
                        });
                        this.dataChanged = false;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadNonAvailabilityReasonsForDay: function () {

                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'dayavailabilityreasons';
                axios
                    .get(url)
                    .then(response => {
                        this.dailyNonAvailabilityOptions = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadNonAvailabilityReasonsForWeek: function () {

                var url = this.apiControllerUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'weekavailabilityreasons';
                axios
                    .get(url)
                    .then(response => {
                        this.weeklyNonAvailabilityOptions = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            updateDataChangedStatus: function () {
                this.dataChanged = true;
            },

            isPastDate: function (weekDayDate) {
                var today = new Date();
                var dateObj = new Date(weekDayDate);
                today.setHours(0, 0, 0, 0);
                dateObj.setHours(0, 0, 0, 0);
                return (dateObj < today);
            },

            getWeekday(index) {
                return this.weekDayArray[index]
            },

            getVariantColor: function (day) {
                if (day == 'SAT' || day == 'SUN') return 'danger'
                else return 'light'
            },

            changeAvailabilityForWholeWeek(reason) {

                var today = new Date();
                today.setHours(0, 0, 0, 0);

                if (reason == '') return;

                for (var i = 0; i < 7; i++) {
                    var dateObj = new Date(this.availability.days[i].date);
                    dateObj.setHours(0, 0, 0, 0);
                    if (dateObj >= today) {
                        this.availability.days[i].reasonUnavailable = reason;
                        // this is hacky
                        if (reason == null) {
                            this.availability.days[i].reasonUnavailableDisplayName = null;
                        } 
                        else {
                            this.availability.days[i].reasonUnavailableDisplayName = this.weeklyNonAvailabilityOptions.find(x => x.value === reason).text;
                        }
                    }
                    if (this.availability && dateObj >= today) {
                        this.availability.days[i].am = false;
                        this.availability.days[i].pm = false;
                        this.availability.days[i].audioMinutes = null;
                        this.availability.days[i].availableForTravel = null;
                        this.availability.days[i].availableForOnSite = null;
                        this.availability.days[i].availableForRealTime = null;
                        // this is hacky
                        if (reason == null) {
                            this.availability.days[i].reasonUnavailableDisplayName = null;
                        }
                        else {
                            this.availability.days[i].reasonUnavailableDisplayName = this.weeklyNonAvailabilityOptions.find(x => x.value === reason).text;
                        }
                    }
                }
                this.dataChanged = true;
                //this.dailySelected = [reason, reason, reason, reason, reason, reason, reason]; // Frage
            },

            changeAvailabilityForOneDay(dayOfWeek) {
                if (dayOfWeek.reasonUnavailable != null) {
                    dayOfWeek.reasonUnavailableDisplayName = this.dailyNonAvailabilityOptions.find(x => x.value === dayOfWeek.reasonUnavailable).text;
                    dayOfWeek.audioMinutes = null;
                    dayOfWeek.availableForTravel = null;
                    dayOfWeek.availableForOnSite = null;
                    dayOfWeek.availableForRealTime = null;                   
                } else {
                    dayOfWeek.reasonUnavailableDisplayName = null;
                }
                this.dataChanged = true;
            },

            checkForDataChangeAndClose: function (bvModalEvt) {
                if (this.dataChanged) {
                    this.showUnsavedDataModal();
                    bvModalEvt.preventDefault();
                } else {
                    // this.active = false; // Frage: In order not to manipulate the Prop active we change the dialog open.
                    this.dialogOpen = false;
                }
            },

            onDialogHidden: function () {
                this.weeklySelected = '';
                this.availability = null;
                this.$emit('change', false);
                if (this.availabilityUpdated) {
                    this.$emit('availabilityUpdated', false);
                }
            },

            onOpenPopover(index,date) {

                // this ensures that Comment PopUp for comments in th past does not open for editing
                if (this.isPastDate(date)) { return;  }

                //first lets close all popovers
                this.commentsPopover.forEach((commentPopover) => {
                    commentPopover.open = false;
                });
                //then take the current comment from the day and put it into the comments dispayed in the popover
                this.commentsPopover[index].comments = this.availability.days[index].comments;
                //finally, we need to wait until any previous popovers have closed, and then open the requested one
                this.$nextTick(() => {
                    this.commentsPopover[index].open = true;
                })
            },
            onClosePopover(index) {
                this.commentsPopover[index].open = false;
            },
            onSavePopover(index) {
                //save the comments displayed in the popover into the actual days comments
                this.availability.days[index].comments = this.commentsPopover[index].comments;
                this.dataChanged = true;
                //and close the popover
                this.onClosePopover(index);
            },
            onPopoverShown(index) {
                // Called just after the popover has been shown
                // Transfer focus to the first input
                this.focusRef(this.$refs['comments' + index][0]);
            },
            onPopoverHidden(index) {
                // Called just after the popover has finished hiding
                // Bring focus back to the button
                this.focusRef(this.$refs['commentsbutton' + index][0]);
            },
            focusRef(ref) {
                // Some references may be a component, functional component, or plain element
                // This handles that check before focusing, assuming a `focus()` method exists
                // We do this in a double `$nextTick()` to ensure components have
                // updated & popover positioned first
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        (ref.$el || ref).focus();
                    })
                })
            },
            getCommentsButtonVariant(index) {
                if (this.availability.days[index].comments) return 'info'; else return 'secondary';
            },
            editAvailabilityDay(dayObj) {
                this.dateToEdit = new Date(dayObj.date);
                this.dayToEdit = dayObj;

               // if (!this.selectedUserAccountId) this.dayEditModalTitle = "My Availability: ";
               // else this.dayEditModalTitle = "Availability for " + this.selectedUserAccountDisplayName + ": ";

                this.dayEditModalTitle = this.title + ' - ';
                this.dayEditModalTitle += this.formatDateTime(dayObj.date, 'ddd DD/MM/YYYY', true, true); // + " (week " + this.weekNr + ")";
                this.showDayEdit = true;
            }
        },

        mounted: function () {
            
            this.loadNonAvailabilityReasonsForDay();
            this.loadNonAvailabilityReasonsForWeek();
        }
    }
</script>

<style scoped>
    .day.unavailable {
        color: #DC3545;
    }
    .comments-popover {
        min-width: 30rem;
    }
</style>